module.exports = __webpack_public_path__ + "media/images/lb/818-67b44d67b90f15839da407f84235bdfd.svg";